import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ProofsOfDestructionActions} from '../store';
import {ProofsOfDestructionSelectors} from '../store/selectors';

@Injectable()
export class ProofsOfDestructionLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadProofsOfDestructionDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadProofsOfDestructionDone() {
    return this.store.pipe(
      select(ProofsOfDestructionSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ProofsOfDestructionActions.ReadProofsOfDestruction());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
